import axios, { AxiosResponse } from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { TlfItemIndexReadDto } from "../tlfItem/TlfItemIndexReadDto";
import { HierarchyQueryParams } from "./HierarchyQueryParams";

export type ITlfIndexReturn = IAxiosReturn<TlfItemIndexReadDto[]>;

/**
 * Load TLF index entries for a hierarchy.
 *
 * @param backEndUrl - Base backend URL
 * @param hierarchy - Query parameters identifying the hierarchy
 * @param controller - Optional AbortController
 * @returns List of TLF index entries wrapped in iTlfIndexReturn
 */
export const loadHierarchyTlfs = async (
  backEndUrl: string,
  hierarchy: HierarchyQueryParams,
  controller?: AbortController,
): Promise<ITlfIndexReturn> => {
  let url = `${backEndUrl}TlfItems/Hierarchy/${hierarchy.hierarchyId}`;
  if (hierarchy.parentTag) url += `?parentTag=${hierarchy.parentTag}`;
  // Get data
  try {
    const response: AxiosResponse = await axios.get(
      url,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );

    // Return successful result
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Load hierarchy tlfs failed", error);
  }
};
